import { Component } from 'react';

class FunctionalDementiaScale extends Component {
  render() {
    return <h1>Functional Dementia Scale</h1>;
  }
}

export default FunctionalDementiaScale;
